module.exports = __webpack_public_path__ + "public/SiteIcons/writeIcon.svg?61f5fc39";